import router from "../../../router";
import axios from "axios";

export default {
    loadSettingList({ commit }, payload)
    {
        return new Promise((resolve, reject) => {
            let filter_fields = this.getters['settings/getSettingFilterFields'];
            let main_filter = this.getters['settings/getSettingMainFilter'];

            if (!main_filter && router.currentRoute.query.main_filter) {
                main_filter = router.currentRoute.query.main_filter;

                commit('setSettingFilterFieldsMutation', {main_filter: router.currentRoute.query.main_filter});
            }

            if (!filter_fields.settingNumber && router.currentRoute.query.setting_number) {
                filter_fields.settingNumber = router.currentRoute.query.setting_number;

                commit('setSettingFilterFieldsMutation', {field_name: 'settingNumber', field_value: router.currentRoute.query.setting_number})
            }

            if (!filter_fields.settingTitle && router.currentRoute.query.setting_title) {
                filter_fields.settingTitle = router.currentRoute.query.setting_title;

                commit('setSettingFilterFieldsMutation', {field_name: 'settingTitle', field_value: router.currentRoute.query.setting_title})
            }

            if (!filter_fields.settingSlug && router.currentRoute.query.setting_slug) {
                filter_fields.settingSlug = router.currentRoute.query.setting_slug;

                commit('setSettingFilterFieldsMutation', {field_name: 'settingSlug', field_value: router.currentRoute.query.setting_slug})
            }

            payload['filter_fields'] = filter_fields;
            payload['main_filter'] = main_filter;

            axios.post('/api/setting/list', payload).then((response) => {
                const result = response.data.data;

                if (response.data.data.code != 'ok')
                {
                    resolve({
                        error: true,
                        error_msg: 'Server response code not ok!',
                    });

                    return;
                }

                if (!response.data.data.result) {
                    resolve({
                        error: true,
                        error_msg: 'Result is empty!',
                    });

                    return;
                }

                commit('setSettingList', response.data.data.result.settings);
                commit('setSettingListCount', response.data.data.result.settings_count);

                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    },
    setSettingFilterFields({ commit }, payload)
    {
        commit('setSettingFilterFieldsMutation', payload);
    },
    deleteSettings({ commit }, payload)
    {
        return new Promise((resolve, reject) => {
            axios.post('/api/setting/delete-settings', {
                ids: payload
            }).then(response => {
                const result = response.data.data;

                if (response.data.data.result.success !== true) {
                    resolve(false);
                }

                commit('deleteSettingsMutation', payload);

                resolve(true);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setSettingModalOpen({commit}, payload)
    {
        commit('setSettingModalOpenMutation', payload);
    },
    setSettingIdAndSettingIndexToModalForm({commit}, payload)
    {
        commit('setSettingIdAndSettingIndexToModalFormMutation', payload);
    },
    addSettingToSettingList({commit}, payload)
    {
        commit('addSettingToSettingList', payload);
    },
    updateSetting({ commit }, payload)
    {
        commit('updateSetting', payload);
    },
    setNotVerifiedClientCount({commit}, payload)
    {
        commit('setNotVerifiedClientCount', payload);
    },
    setNotClosedTickets({commit}, payload)
    {
        commit('setNotClosedTickets', payload);
    },
    setRoles({commit}, payload)
    {
        commit('setRoles', payload);
    },
    setPermissions({commit}, payload)
    {
        commit('setPermissions', payload);
    },
    setNotOpenedTickets({commit}, payload)
    {
        commit('setNotOpenedTickets', payload);
    },
}
